import React from 'react';

/**
 * Renders the UniqCamp wordmark from each app’s `public/uniqcamp-logo.png`.
 */
export default function UniqCampLogo(props) {
  const { alt = 'UniqCamp', style, className } = props || {};
  return React.createElement('img', {
    src: '/uniqcamp-logo.png',
    alt,
    className,
    style: Object.assign(
      {
        display: 'block',
        maxWidth: '100%',
        height: 'auto',
        objectFit: 'contain',
      },
      style || {},
    ),
  });
}
